import React, { useEffect } from "react";
import styles from "../../styles/components/common/AdSlot.module.css";
import {
  ADSENSE_CLIENT,
  ADSENSE_ENABLED_FLAG,
  ADSENSE_SLOT_PRODUCT,
  ADSENSE_SLOT_FEED,
  ADSENSE_SLOT_CATEGORY,
} from "../../config/env";

const ADSENSE_ENABLED = ADSENSE_ENABLED_FLAG === "true" && Boolean(ADSENSE_CLIENT);

const SLOT_IDS = {
  product: ADSENSE_SLOT_PRODUCT,
  feed: ADSENSE_SLOT_FEED,
  category: ADSENSE_SLOT_CATEGORY,
};

/**
 * Env-gated display ad slot. Renders nothing until AdSense is configured.
 * Set REACT_APP_ADSENSE_ENABLED=true, REACT_APP_ADSENSE_CLIENT=ca-pub-xxx,
 * and REACT_APP_ADSENSE_SLOT_PRODUCT (etc.) then rebuild.
 */
function ensureAdSenseScript() {
  if (typeof document === "undefined" || !ADSENSE_CLIENT) return;
  const existing = document.querySelector(
    `script[src*="adsbygoogle"][data-ad-client="${ADSENSE_CLIENT}"]`,
  );
  if (existing) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  script.crossOrigin = "anonymous";
  script.dataset.adClient = ADSENSE_CLIENT;
  document.head.appendChild(script);
}

const AdSlot = ({ slot = "product", format = "auto", className = "" }) => {
  const slotId = SLOT_IDS[slot] || "";

  useEffect(() => {
    if (!ADSENSE_ENABLED || !slotId) return;
    ensureAdSenseScript();
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // Ad blockers / missing script — ignore
    }
  }, [slotId]);

  if (!ADSENSE_ENABLED || !slotId) {
    return null;
  }

  return (
    <aside
      className={`${styles.adSlot} ${className}`.trim()}
      aria-label="Advertisement"
    >
      <ins
        className={`adsbygoogle ${styles.adIns}`}
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slotId}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </aside>
  );
};

export default AdSlot;
